module.exports = __webpack_public_path__ + "img/icon-phone.358b4274.png";